import { darken, rgba, setLightness } from 'polished';
import styled from 'styled-components';

import { SafeMotionDiv } from '../../animation/SafeMotionDiv';

interface BackgroundDimmerNakedProps {
  $opacity: number;
  $zIndex?: number;
}

export const BackgroundDimmerNaked = styled(
  SafeMotionDiv,
)<BackgroundDimmerNakedProps>`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme, $opacity }) =>
    rgba(darken(0.47, setLightness(0.5, theme.colors.primary)), $opacity)};
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex};
`;
